import React from "react";
import Grid from "../layout/grid";
import Select from "react-select";

export default (props) => {
    const normalizarBusca = (valor = "") => {
        return String(valor)
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .replace(/[.\-\/\s]/g, "");
    };
    const propsInput = props.input || {};
    const listaOptions = (props.options || []).map((opt) => ({
        value: String(opt.id),
        label: opt.valor,
        isDisabled: !!opt.disabled,
    }));
    const valueRecebido = props.value || propsInput.value;
    const valueMultiplo = valueRecebido instanceof Array && valueRecebido.length >= 0;
    const valueIndividual = listaOptions.find((opt) => opt.value == valueRecebido) || "";
    const estilo = props.style || {};
    const valueSelecionado = valueMultiplo ? valueRecebido : valueIndividual;

    const onChange = props.onChange || propsInput.onChange;
    const onBlur = () => (propsInput.onBlur ? propsInput.onBlur() : null);
    return (
        <Grid cols={props.cols} style={{ marginBlock: props.gridMarginBlock != null ? props.gridMarginBlock : 3, paddingTop: props.paddingTop || null }}>
            <div className={props.noFormGroup ? "" : `form-group`} style={{ ...estilo }}>
                {props.label ? <label htmlFor={props.name}>{props.label}</label> : null}
                <Select
                    menuPortalTarget={document.body}
                    filterOption={(option, inputValue) => {
                        const busca = normalizarBusca(inputValue);
                        const valorOpcao = normalizarBusca(option.label);
                        return valorOpcao.includes(busca);
                    }}
                    styles={{
                        menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
                        control: (provided, state) => ({
                            ...provided,
                            color: state.isDisabled ? "#333" : estilo.color || "#000",
                            backgroundColor: state.isDisabled ? "#f0f0f0" : estilo.backgroundColor || "#fff", // Set the background color for disabled state
                            opacity: state.isDisabled ? 0.5 : 1, // Optional: adjust opacity for disabled state
                            cursor: state.isDisabled ? "not-allowed" : "default", // Change the cursor for disabled state
                        }),
                        menu: (provided) => ({
                            ...provided,
                            backgroundColor: estilo.backgroundColor || "#FFF",
                            color: estilo.color,
                        }),
                        option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isDisabled ? "#F7F7F7" : state.isFocused ? "#EEEEEE" : estilo.backgroundColor || "#FFF",
                            color: state.isDisabled ? "#999" : state.isSelected || state.isFocused ? "#000" : estilo.color,
                            cursor: state.isDisabled ? "not-allowed" : "default",
                        }),
                        singleValue: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? "#EEEEEE" : estilo.backgroundColor || "#FFF", // Estilo para opções dentro do menu
                            color: estilo.color, // Cor do texto da opção selecionada
                        }),
                        multiValue: (provided, state) => ({
                            ...provided,
                            filter: "contrast(0.9)",
                            backgroundColor: state.isFocused ? "#EEEEEE" : estilo.backgroundColor || "#FFF", // Estilo para opções dentro do menu
                            color: estilo.color, // Cor do texto das opções selecionadas quando multi
                        }),
                        multiValueLabel: (provided) => ({
                            ...provided,
                            color: estilo.color, // <-- COR DO TEXTO DOS SELECIONADOS
                        }),
                        multiValueRemove: (provided) => ({
                            ...provided,
                            color: "#666",
                            ":hover": {
                                backgroundColor: "#EEE",
                                color: "#000",
                            },
                        }),
                    }}
                    placeholder={props.placeholder}
                    isDisabled={props.readOnly || !listaOptions.length}
                    value={valueSelecionado}
                    isClearable={props.isClearable == null || props.isClearable}
                    isSearchable={props.isSearchable == null || props.isSearchable}
                    isMulti={props.isMulti}
                    isOptionDisabled={(option) => !!option.isDisabled}
                    onChange={(item) => onChange(item ? (props.getTarget ? { name: props.name, value: item.value } : props.isMulti ? item : item.value) : null)}
                    onBlur={() => onBlur()}
                    options={listaOptions}
                />
            </div>
        </Grid>
    );
};
